import React from 'react';
import { ExportPermissionsSectionProps } from '../types';
import ExportPermissionItem from './ExportPermissionItem';

/**
 * Component for rendering the exports section of the permission table
 */
const ExportPermissionsSection: React.FC<ExportPermissionsSectionProps> = ({
  exportPermissions,
  selectedPermissions,
  onSelectPermission,
}) => {
  if (exportPermissions.length === 0) return null;

  return (
    <div
      className="mb-4 border border-neutral-200 rounded-lg"
      data-testid="permission-group-exports"
    >
      <div
        className="px-4 py-3 bg-neutral-50 border-b border-neutral-200"
        data-testid="group-header-exports"
      >
        <div className="text-sm font-semibold text-neutral-700">Exports</div>
      </div>
      <div className="grid grid-cols-1 min-[1015px]:grid-cols-2 gap-2 p-2">
        {exportPermissions.map((permission) => (
          <ExportPermissionItem
            key={permission.permissionCode}
            permission={permission}
            selectedPermissions={selectedPermissions}
            onSelectPermission={onSelectPermission}
          />
        ))}
      </div>
    </div>
  );
};

export default ExportPermissionsSection;
